import { useSyncExternalStore } from 'react';
import s from './ui.module.css';

interface Item {
  id: number;
  text: string;
  tone: 'ok' | 'danger';
}

let items: Item[] = [];
let next = 1;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

/** A short confirmation in the corner after an action succeeds (or a quiet note that it didn't). */
export function toast(text: string, tone: Item['tone'] = 'ok') {
  const id = next++;
  items = [...items, { id, text, tone }];
  emit();
  window.setTimeout(() => {
    items = items.filter((i) => i.id !== id);
    emit();
  }, 3600);
}

export function Toaster() {
  const list = useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => items,
  );
  return (
    <div className={s.toasts} role="status" aria-live="polite">
      {list.map((t) => (
        <div key={t.id} className={s.toast} data-tone={t.tone}>
          {t.tone === 'ok' ? '✓ ' : '✕ '}
          {t.text}
        </div>
      ))}
    </div>
  );
}
